<div tabindex="-1" class="cell-input" [class.error]="!!error">
  @switch (cellInputType) {
    @case ('Boolean') {
      <!-- #region Boolean -->
      <blaze-cell-input-boolean
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Text') {
      <!-- #region Object | String (Single Line) | UpdatedBy | CreatedBy | Email | Url -->
      <blaze-cell-input-text
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Formula') {
      <!-- #region readonly Formula: !Number !File !Image !Duration readonly -->
      <blaze-cell-input-text
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Secure') {
      <!-- #region SecureText -->
      <blaze-cell-input-secure-text
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Paragraph') {
      <!-- #region String (Multi Line) -->
      <blaze-cell-input-text-multi-line
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Number') {
      <!-- #region Number | AutoNumber | Formula:Number -->
      <blaze-cell-input-number
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        [readonly]="column | isColumnType: 'Formula'"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('PhoneNumber') {
      <!-- #region Phone -->
      <blaze-cell-input-phone
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Duration') {
      <!-- #region Duration -->
      <blaze-cell-input-duration
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled || (column | isColumnType: 'Formula')"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('GeoPoint') {
      <!-- #region Location -->
      <blaze-cell-input-geo-point
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [placeholder]="placeholder"
        [isDisabled]="isDisabled || (column | isColumnType: 'Formula')"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('TimeZone') {
      <!-- #region Timezone -->
      <blaze-cell-input-timezone
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Signature') {
      <!-- #region Signature -->
      <blaze-cell-input-signature
        [forceFocusAfterInit]="forceFocusAfterInit"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Tag') {
      <!-- #region Tag -->
      <blaze-cell-input-tag
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('File') {
      <!-- #region File | Image -->
      <blaze-cell-input-file
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [projectId]="projectId"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('Link') {
      <!-- #region Link -->
      <blaze-cell-input-link
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [columns]="columns"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @case ('DateTime') {
      <!-- #region DateTime | Date | Time | CreatedTime | LastUpdatedTime -->
      <blaze-cell-input-date-time
        [forceFocusAfterInit]="forceFocusAfterInit"
        [extraStartAction]="extraStartAction"
        [column]="column"
        [value]="value"
        [isDisabled]="isDisabled"
        [selectedText]="selectedText"
        [selectedTextOffset]="selectedTextOffset"
        (valueChanged)="emitValueChanged($event)"
        (focusLost)="emitFocusLost($event)"
      />
    }
    @default {
      <span class="text-error">
        Unsupported column type: {{ column.columnType }}, data type: {{ column.dataType }} or format
        {{ column.format?.formatType }}
      </span>
    }
  }
</div>
